import {FormGroup, TextField, Button, MenuItem, Select, InputLabel, FormControl, Paper, Typography} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {  useEffect, useState } from "react";
//import { useDispatch, useSelector } from "react-redux";
//import { getTripbyId, updateTrip, getCustomerbyId} from "../actions/customer"
import { fetchSupplierbyId, updateSupplierdata, fetchDest } from "../api/customerapi";
import { v4 as uuidv4 } from 'uuid';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    checkboxalign:{
       alignSelf: "center",
       justifyContent: "center",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      
      
    }));

    

    // function useMyhook() {
    //     const dataFromDB= useSelector((state)=> state.reducerNames);
    //     return dataFromDB;
    // }
const Supplierdataupdate = () => {

    const classes = useStyles();
    //const dispatch=useDispatch();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [contactData, setcontactData] =useState([{
            
        role: "",
        name: "",
        email:""
}]);
const [newcontactData, setnewcontactData] =useState({})
const [dest, setdest]=useState([])
    

const [supplierData, setsupplierData] =useState({
    supplier_name: "",
    supplier_id:0,
    supplier_destinations: "",
    supplier_address: "",
    supplier_type: "",
    supplier_payment_rule:"",
    supplier_bankinfo: "",
    supplier_contact: [{
        contact: 0,
        role: "",
        name: "",
        email:"",
        id:""
    }] 
    
})
   
   
    const getSupplier = async (id) => {
        try{
        const data = await fetchSupplierbyId(id);
        setsupplierData(data.data)
        setcontactData(data.data.supplier_contact)
    }catch(err){
        console.log(err)
      }
    }

    const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      };

    useEffect(() => {
        getDest()
        getSupplier(currentid)
    }, [])
   


      const deletecontact=(supid) =>{
        //console.log(contactData);
        //console.log(supid);
          setcontactData(
              contactData.filter(sup => sup.id !== supid)
          )
          //console.log(contactData);

      }

      const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        
        
        const finalnewcontactData = (Object.keys(newcontactData).length && newcontactData.constructor === Object)? {...newcontactData, id:uuidv4()} :null
        //console.log(Object.keys(newcontactData).length);
        const finalcontactData=(finalnewcontactData)? [...contactData, finalnewcontactData] : [...contactData]
        const finalsupplierData= {...supplierData, supplier_contact:finalcontactData};
        //dispatch(updateTrip(tripData._id, finaltripData));
        //console.log(finalsupplierData);
     
        const updatesupplierResponse= await updateSupplierdata(supplierData._id, finalsupplierData);
        if(updatesupplierResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for supplier with supplier id "+updatesupplierResponse.data.supplier_id);
            window.location = ("/supplierdataentry/"+updatesupplierResponse.data.supplier_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }catch(err){
        console.log(err)
      }
    }

   

    return (  
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Update Supplier</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  InputLabelProps={{ shrink: true }} value={supplierData.supplier_name} className={classes.textField} onChange={(e)=> setsupplierData({...supplierData, supplier_name: e.target.value})}/>
                <TextField variant="standard"  label="Address"  InputLabelProps={{ shrink: true }} value={supplierData.supplier_address} className={classes.textField} onChange={(e)=> setsupplierData({...supplierData, supplier_address: e.target.value})}/>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Type">Destination *</InputLabel>
                <Select displayEmpty required classname={classes.textField} labelId="Type" value={supplierData.supplier_destinations} onChange={(e)=> setsupplierData({...supplierData, supplier_destinations: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})} 
                </Select>
                </FormControl>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Type">Supplier Type *</InputLabel>
                <Select displayEmpty required classname={classes.textField} labelId="Type" value={supplierData.supplier_type} onChange={(e)=> setsupplierData({...supplierData, supplier_type: e.target.value})}>
                    <MenuItem value={"DMC"}>DMC</MenuItem>
                    <MenuItem value={"Hotel"}>Hotel</MenuItem>
                    <MenuItem value={"Hotel Portal"}>Hotel Portal</MenuItem>
                    <MenuItem value={"Cab driver"}>Cab driver</MenuItem>
                    <MenuItem value={"Cab agency"}>Cab agency</MenuItem>
                    <MenuItem value={"Restaurant"}>Restaurant</MenuItem>
                    <MenuItem value={"Visa agency"}>Visa agency </MenuItem>
                    <MenuItem value={"Insurance agency"}>Insurance agency</MenuItem>
                    <MenuItem value={"Flight"}>Flight</MenuItem>
                    <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Rules">Payment Rules *</InputLabel>
                <Select required classname={classes.textField} labelId="Rules" value={supplierData.supplier_payment_rule} onChange={(e)=> setsupplierData({...supplierData, supplier_payment_rule: e.target.value})}>
                    <MenuItem value={"Day of Booking"}>Day of Booking</MenuItem>
                    <MenuItem value={"3 days before date of travel"}>3 days before date of travel</MenuItem>
                    <MenuItem value={"7 days before date of travel"}>7 days before date of travel</MenuItem>
                    <MenuItem value={"15 days before date of travel"}>15 days before date of travel</MenuItem>
                    <MenuItem value={"21 days before date of travel"}>21 days before date of travel</MenuItem>
                    <MenuItem value={"30 days before date of travel"}>30 days before date of travel</MenuItem>
                    <MenuItem value={"45 days before date of travel"}>45 days before date of travel</MenuItem>
                    <MenuItem value={"Every 15 days post travel"}>Every 15 days post travel</MenuItem>
                    <MenuItem value={"Date of travel"}>Date of travel</MenuItem>
                    {/* <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem> */}
                    <MenuItem value={"Custom"}>Custom</MenuItem>
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Bank Information"  InputLabelProps={{ shrink: true }} value={supplierData.supplier_bankinfo} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> setsupplierData({...supplierData, supplier_bankinfo: e.target.value})}/>
            </FormGroup>

            {/* {supplierData?.supplier_contact && (
            supplierData.supplier_contact.map((sup) => { 
            return <div>  */}
          {contactData?.map(sup => {
            return <div> 
            <Typography variant="h6" align="center" className={classes.headertext}> Contact {contactData.indexOf(sup)+1}</Typography>
            <FormGroup row className={classes.formgroup}>
                <TextField disabled variant="standard"  id="name" label="Name"  InputLabelProps={{ shrink: true }} value={sup.name} className={classes.textField} />
                <TextField disabled variant="standard"  id="contact" label="Contact (number)" InputLabelProps={{ shrink: true }} value={sup.contact} className={classes.textField} />
                <TextField disabled variant="standard"  id="email" label="Email"  InputLabelProps={{ shrink: true }} value={sup.email} className={classes.textField} />
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Role">Role *</InputLabel>
                <Select displayEmpty disabled classname={classes.textField} id="role" labelId="Role" value={sup.role} >
                    <MenuItem value={"Owner/CEO"}>Owner/CEO</MenuItem>
                    <MenuItem value={"Management"}>Management</MenuItem>
                    <MenuItem value={"Sales"}>Sales</MenuItem>
                    <MenuItem value={"Operations"}>Operations</MenuItem>
                    <MenuItem value={"Customer service"}>Customer service</MenuItem>
                    <MenuItem value={"Accounts"}>Accounts </MenuItem>
                   
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                
                </FormControl>
                <Button variant="contained" color="secondary" className={classes.button} onClick={() => deletecontact(sup.id)}>Delete</Button>
            </FormGroup>
             </div>
            
            })} 

            <div> 
            <Typography variant="h6" align="center" className={classes.headertext}> New Contact </Typography>
            <FormGroup row className={classes.formgroup}>
                <TextField  variant="standard"  label="Name"  value={newcontactData.name} className={classes.textField} onChange={(e)=> setnewcontactData({...newcontactData, name: e.target.value})}/>
                <TextField  variant="standard"  label="Contact (number)"  value={newcontactData.contact} className={classes.textField} onChange={(e)=> setnewcontactData({...newcontactData, contact: e.target.value})} />
                <TextField  variant="standard"  label="Email"   value={newcontactData.email} className={classes.textField} onChange={(e)=> setnewcontactData({...newcontactData, email: e.target.value})} />
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Role">Role</InputLabel>
                <Select  displayEmpty classname={classes.textField} labelId="Role" value={newcontactData.role} onChange={(e)=> setnewcontactData({...newcontactData, role: e.target.value})} >
                    <MenuItem value={"Owner/CEO"}>Owner/CEO</MenuItem>
                    <MenuItem value={"Management"}>Management</MenuItem>
                    <MenuItem value={"Sales"}>Sales</MenuItem>
                    <MenuItem value={"Operations"}>Operations</MenuItem>
                    <MenuItem value={"Customer service"}>Customer service</MenuItem>
                    <MenuItem value={"Accounts"}>Accounts </MenuItem>
                   
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
            </FormGroup>
             </div>

            

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                <Button href={"/supplierdatarecord/"+supplierData.supplier_name} variant="contained" color="secondary" className={classes.button}>Supplier Record</Button>
            </FormGroup>
              
            </form>
        </Paper>
    );
}
 
export default Supplierdataupdate;